import { c as _c } from "react/compiler-runtime";
import { useGradientAnimation } from '@/hooks/useGradientAnimation';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
type GradientVariant = {
  background: string;
  color: string;
};
interface AnimatedGradientButtonProps {
  label: string;
  linkTo: string;
  baseColor?: GradientVariant;
  gradients: GradientVariant[];
  icon?: React.ReactNode;
  biKey?: string;
  captureAttributes?: Record<string, string>;
  className?: string;
  buttonClassName?: string;
  disabled?: boolean;
  onClick?: () => void;
}
const defaultBase: GradientVariant = {
  background: '#00A0CB',
  color: 'rgba(255,255,255,1)'
};
export function AnimatedGradientButton(t0) {
  const $ = _c(37);
  const {
    label,
    linkTo,
    baseColor: t1,
    gradients,
    icon,
    biKey,
    captureAttributes,
    className,
    buttonClassName,
    disabled: t2,
    onClick: customOnClick
  } = t0;
  const baseColor = t1 === undefined ? defaultBase : t1;
  const disabled = t2 === undefined ? false : t2;
  const controls = useGradientAnimation();
  let t3;
  if ($[0] !== customOnClick || $[1] !== disabled || $[2] !== linkTo) {
    t3 = () => {
      if (disabled) {
        return;
      }
      if (customOnClick) {
        customOnClick();
      } else {
        window.location.href = linkTo;
      }
    };
    $[0] = customOnClick;
    $[1] = disabled;
    $[2] = linkTo;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleClick = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      duration: 0.3,
      ease: "easeOut"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== baseColor.background || $[6] !== baseColor.color) {
    t5 = {
      background: baseColor.background,
      color: baseColor.color,
      transition: t4
    };
    $[5] = baseColor.background;
    $[6] = baseColor.color;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = gradients[0]?.background;
  const t7 = gradients[0]?.color;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      duration: 1,
      ease: "easeOut"
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t6 || $[10] !== t7) {
    t9 = {
      background: t6,
      color: t7,
      transition: t8
    };
    $[9] = t6;
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = gradients[1]?.background;
  const t11 = gradients[1]?.color;
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      duration: 1,
      ease: "easeOut"
    };
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t10 || $[14] !== t11) {
    t13 = {
      background: t10,
      color: t11,
      transition: t12
    };
    $[13] = t10;
    $[14] = t11;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t13 || $[17] !== t5 || $[18] !== t9) {
    t14 = {
      base: t5,
      gradient1: t9,
      gradient2: t13
    };
    $[16] = t13;
    $[17] = t5;
    $[18] = t9;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const variants = t14;
  const t15 = !disabled;
  let t16;
  if ($[20] !== className || $[21] !== t15) {
    t16 = cn("size-full", className, {
      "cursor-pointer": t15
    });
    $[20] = className;
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== buttonClassName) {
    t17 = cn("relative flex w-full items-center justify-center gap-2 rounded-full px-[20px] py-[12px] text-center text-[18px] leading-[22px] font-semibold tracking-[0.2px]", buttonClassName);
    $[23] = buttonClassName;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== controls || $[26] !== icon || $[27] !== label || $[28] !== t17 || $[29] !== variants) {
    t18 = <motion.div initial="base" animate={controls} variants={variants} className={t17}>{icon}{label}</motion.div>;
    $[25] = controls;
    $[26] = icon;
    $[27] = label;
    $[28] = t17;
    $[29] = variants;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== biKey || $[32] !== captureAttributes || $[33] !== handleClick || $[34] !== t16 || $[35] !== t18) {
    t19 = <div data-bi-key={biKey} {...captureAttributes} onClick={handleClick} className={t16}>{t18}</div>;
    $[31] = biKey;
    $[32] = captureAttributes;
    $[33] = handleClick;
    $[34] = t16;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  return t19;
}